import styles from '../../assets/css/error.module.css';
import { TechnicalErrorIcon } from '../svgs/TechnicalErrorIcon';
import SupportIcon from '../svgs/SupportIcon';
import TimeIcon from '../svgs/TimeIcon';
import useCustomization from '../../hooks/useCustomization';
import TextCustomization from '../customizations/TextCustomization';
import { CustomizationKey } from '../../contexts/CustomizationsContext';

interface SessionErrorPageProps {
	errorMessage: string;
}

const FINCREDIBLE_XS2A_ERROR_PAGE_TITLE_KEY: CustomizationKey = 'FINCREDIBLE_XS2A_ERROR_PAGE_TITLE';
const FINCREDIBLE_XS2A_ERROR_PAGE_INFO_KEY: CustomizationKey = 'FINCREDIBLE_XS2A_ERROR_PAGE_INFO';
const FINCREDIBLE_XS2A_ERROR_PAGE_SUPPORT_SECTION_KEY: CustomizationKey = 'FINCREDIBLE_XS2A_ERROR_PAGE_SUPPORT_SECTION';
const FINCREDIBLE_XS2A_ERROR_PAGE_SUPPORT_SUBSECTION_KEY: CustomizationKey =
	'FINCREDIBLE_XS2A_ERROR_PAGE_SUPPORT_SUBSECTION';

const SessionError = ({ errorMessage }: SessionErrorPageProps) => {
	const errorPageTitleText = useCustomization(FINCREDIBLE_XS2A_ERROR_PAGE_TITLE_KEY);
	const errorPageInfoText = useCustomization(FINCREDIBLE_XS2A_ERROR_PAGE_INFO_KEY);
	const errorPageSupportSectionText = useCustomization(FINCREDIBLE_XS2A_ERROR_PAGE_SUPPORT_SECTION_KEY);
	const errorPageSupportSubsectionText = useCustomization(FINCREDIBLE_XS2A_ERROR_PAGE_SUPPORT_SUBSECTION_KEY);

	return (
		<div className={styles['session-error-page']}>
			<div className={styles['icon-container']}>
				<div className={styles['icon']}>
					<TechnicalErrorIcon />
				</div>
			</div>
			<div className={styles['header']}>
				<div className={styles['title']}>
					<span>
						<TextCustomization content={errorPageTitleText} />
					</span>
				</div>
				<div className={styles['subtitle']}>
					<span>{errorMessage}</span>
				</div>
			</div>
			<div className={styles['content']}>
				<div className={styles['reference-container']}>
					<div className={styles['reference-text']}>
						<span>
							<TextCustomization content={errorPageInfoText} />
						</span>
					</div>
				</div>

				<div className={styles['support-container']} style={{ paddingBottom: '0' }}>
					<div className={styles['support-icon-container']}>
						<SupportIcon />
					</div>
					<div className={styles['support-content']}>
						<div className={styles['support-text']}>
							<span>
								<TextCustomization content={errorPageSupportSectionText} />
							</span>
						</div>
					</div>
				</div>

				<div className={styles['support-container']} style={{ paddingTop: '10px' }}>
					<div className={styles['support-icon-container']}>
						<TimeIcon />
					</div>
					<div className={styles['support-content']}>
						<div className={styles['support-text']}>
							<span>
								<TextCustomization content={errorPageSupportSubsectionText} />
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SessionError;
